import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { TAGFinanceTransaction } from '../../../models/tagfinances';
import { TAGUser } from '../../../models/taguser';
import { TAGEvent } from '../../../models/tagevent';
import { ApiService } from '../../api.service';
import { SkeletonModule } from 'primeng/skeleton';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { NgxMaskPipe } from 'ngx-mask';
import { MessageService } from 'primeng/api';
import { APIError } from '../../../models/apierror';
import { MatIcon } from "../mat-icon/mat-icon";

@Component({
  selector: 'finance-transaction-list-item',
  imports: [SkeletonModule, DatePipe, ButtonModule, TooltipModule, TranslatePipe, NgxMaskPipe, MatIcon],
  providers: [TranslateService],
  templateUrl: './finance-transaction-list-item.html',
  styleUrl: './finance-transaction-list-item.scss',
})
export class FinanceTransactionListItemComponent {
  private messageService = inject(MessageService);
  private api = inject(ApiService);
  private translate = inject(TranslateService);

  @Input() transaction: TAGFinanceTransaction;
  @Input() users: TAGUser[];
  @Input() events: TAGEvent[];

  @Input() showEditButton: boolean = true;
  @Input() showDeleteButton: boolean = true;
  @Input() showEvent: boolean = true;

  @Output() edit = new EventEmitter();
  @Output() delete = new EventEmitter();

  loadingUser = signal(true);
  user = signal<TAGUser>(undefined);
  loadingEvent = signal(true);
  event = signal<TAGEvent>(undefined);

  constructor() {
  }

  ngOnInit(): void {
    if (this.users?.length > 0) {
      this.user.set(this.users.find((u) => u.username == this.transaction.user));
      this.loadingUser.set(false);
    }

    if (this.events?.length > 0) {
      this.event.set(this.events.find((e) => e._id == this.transaction.event));
      this.loadingEvent.set(false);
    }

    this.api.waitForAPI().then(() => {
      if (this.transaction.user && !this.user()) {
        this.api
          .getUsers()
          .then((users: TAGUser[]) => {
            this.user.set(users.find((u) => u.username == this.transaction.user));
            this.loadingUser.set(false);
          })
          .catch((reason: APIError) => {
            this.messageService.add({
              severity: 'warn',
              summary: this.translate.translate("errors.couldNotLoadUsers")(),
              detail: reason.message,
            });
          });
      }

      if (this.transaction.event && !this.event()) {
        console.log("Requesting Events");
        this.api
          .getEvent(this.transaction.event)
          .then((result: TAGEvent) => {
            this.event.set(result);
            this.loadingEvent.set(false);
          })
          .catch((reason: APIError) => {
            this.messageService.add({
              severity: 'warn',
              summary: this.translate.translate("errors.couldNotLoadEvent")(),
              detail: reason.message,
            });
          });
      }
    });
  }

  openDocument(transactionId: string, fileName: string) {
    this.api
      .getFinanceTransactionAttachment(transactionId, fileName)
      .then((result) => {
        var pdfUrl = window.URL.createObjectURL(result);

        var link = document.createElement('a');
        link.download = fileName;
        link.href = pdfUrl;

        window.open(pdfUrl, '_blank');
      })
      .catch((reason) => {
        console.error(reason);
      });
  }
}
